import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import { useModalData } from '../../../components/modals/ModalsContext'
import BulkExecutionGrid from './bulk/BulkExecutionGrid'
import BulkGridStateProvider from './bulk/_state/BulkGridStateContext'
import ExecutionForm from './ExecutionForm'
import ExecutionFormHandler from './_form/ExecutionFormHandler'
import Footer from './Footer'
import ModalHeader from './ModalHeader'
import ServiceOrderLoader, { useIsBulkExecution } from './_load/ServiceOrderLoader'
import ImperativeComponents from '../../../containers/dynamic/form/replies/context/ImperativeComponentsContext'

// A execução em massa usa uma grade (linhas = atividades, colunas =
// perguntas) em vez do formulário reaproveitado da execução individual — por
// isso o modal precisa ser fullScreen (mais parecido com a tela de cadastro
// em massa, `bulkEdit/EditServiceOrdersModal`). Esse booleano precisa ser
// lido aqui fora, antes do `ServiceOrderLoader` carregar as atividades, então
// usa direto o dado do modal (o mesmo que o loader usa para decidir a query).
const useIsBulkModalRequest = () => Array.isArray(useModalData()?.bulkServiceOrderIds)

const ExecutionBody = () => {
  const isBulk = useIsBulkExecution()
  return isBulk ? <BulkExecutionGrid /> : <ExecutionForm />
}

const EditServiceOrderModal = props => {
  const isBulk = useIsBulkModalRequest()

  return (
    <ControlledModal
      disableHistory
      disableClickOutside
      {...(isBulk ? { fullScreen: true } : { width: '56rem' })}
      {...props}
    >
      <ServiceOrderLoader>
        <ExecutionFormHandler>
          <BulkGridStateProvider>
            <ImperativeComponents>
              <ModalHeader />
              <ExecutionBody />
              <Footer />
            </ImperativeComponents>
          </BulkGridStateProvider>
        </ExecutionFormHandler>
      </ServiceOrderLoader>
    </ControlledModal>
  )
}

export default EditServiceOrderModal
